<template>
  <div class="c-app">
    <CreateNewEventModal ref="createNewEventModal" :canClose="true"/>
    <TheSidebar/>
    <CWrapper>
      <TheHeader/>
      <Notifier/>
      <div class="c-body">
        <main class="c-main">
          <CContainer fluid>
            <router-view></router-view>
          </CContainer>
        </main>
      </div>
    </CWrapper>
  </div>
</template>

<script>
import TheSidebar from './TheSidebar'
import TheHeader from './TheHeader'
import Notifier from "../components/Notifier"
import CreateNewEventModal from "@/domain/events/components/CreateNewEventModal.vue";

export default {
  name: 'TheContainer',
  components: {
    CreateNewEventModal,
    TheSidebar,
    TheHeader,
    Notifier
  },
  methods: {
    async openCreateNewEvent({canClose,isFirstEvent}) {
      await this.$refs.createNewEventModal.open({canClose, isFirstEvent})
    }
  },
}
</script>
